export default __webpack_public_path__ + "images/24c59d46d866c2dcf4128da616852f53.png";